import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVocalMicrophone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVocalMicrophone"><Path fillRule="evenodd" clipRule="evenodd" d="M16.625 11.75C19.0412 11.75 21 9.79125 21 7.375C21 4.95875 19.0412 3 16.625 3C14.2088 3 12.25 4.95875 12.25 7.375C12.25 7.54966 12.2602 7.72193 12.2801 7.89125L16.1088 11.7199C16.2781 11.7398 16.4503 11.75 16.625 11.75Z" stroke="currentColor"/><Path d="M12.5 8L3 18L6 21L16 11.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconVocalMicrophone;
